module.exports = __webpack_public_path__ + "img/protecaoEficazBranco.80720e48.svg";